import React,{useState,useEffect,useRef}from 'react'
import Main from '../cpn/Main'
import { Table,Button,Space,Modal,message,Form,Input,} from 'antd';
import { useSearchParams, } from 'react-router-dom';
import {  useAppMenuAddMutation, useAppMenuDelMutation, useAppMenuListQuery, useAppMenuUpdateQuery, useAppMenuUpdateSaveMutation,  } from '../store/ReactWebSiteApi';

function AppLimit() {
    const [param] = useSearchParams()
    //新增设置-----------------------------------------------------------------------------------------------------------------------------新增设置
    const [form] = Form.useForm();
    const [openAdd, setOpenAdd] = useState(false);
    const onCreateClient = (values) => {
        console.log('Received values of form: ', values);
        setOpenAdd(false);
    };
    const [infoAdd,setInfoAdd] = useState({
        esvm_content:'',
    });
    const [submitAdd] = useAppMenuAddMutation()
    const modalAdd= <Modal
                        open={openAdd}
                        title='新增权限'
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpenAdd(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateClient(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                            submitAdd({
                                esvm_esv_id:param.get('id'),
                                esvm_esv_name:param.get('name'),
                                esvm_name:infoAdd.esvm_name,
                                esvm_content:infoAdd.esvm_content,
                                esvm_uid:localStorage.getItem('eu_id'),
                                esvm_uname:localStorage.getItem('eu_name'),
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('新增成功！')  
                                    setOpenAdd(false)                         
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('新增失败！'+res.data.Message)
                                }
                            })
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 5 }}
                        >
                            <Form.Item label='应用名称' wrapperCol={{span:10}} required>
                                {param.get('name')}
                            </Form.Item>
                            <Form.Item name="name" label='权限' wrapperCol={{span:10}} required>
                                <Input  onChange={(e) => {setInfoAdd(prevState=>({...prevState,esvm_name:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="content" label='备注' wrapperCol={{span:15}} required>
                                <Input  onChange={(e) => {setInfoAdd(prevState=>({...prevState,esvm_content:e.target.value}))}}/>
                            </Form.Item>
                        </Form>
                    </Modal> 
    //修改设置-----------------------------------------------------------------------------------------------------------------------------修改设置
    const [openEdit, setOpenEdit] = useState(false);
    const [editId,setEditId] = useState()
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpenEdit(false);
    };
    const [infoEdit,setInfoEdit] = useState();
    const editForm = useRef()
    const {data:dataEdit,isSuccess:isSuccessEdit} = useAppMenuUpdateQuery({esvm_id:editId},{refetchOnMountOrArgChange:1})
    useEffect(() => {
        if(isSuccessEdit){
            if(dataEdit.Status==='success'){
                console.log(dataEdit);
                editForm.current.setFieldsValue({
                    esvm_name:dataEdit.Result.esvm_name,
                    esvm_content:dataEdit.Result.esvm_content,
                })
                setInfoEdit(prevState=>({...prevState,
                    esvm_name:dataEdit.Result.esvm_name,
                    esvm_content:dataEdit.Result.esvm_content,              
                }))
            }
        }
    },[dataEdit,isSuccessEdit])
    const [submitUpdateSave] = useAppMenuUpdateSaveMutation()
    const modalEdit = <Modal
                        open={openEdit}
                        title='修改权限'
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpenEdit(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateEdit(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                            submitUpdateSave({
                                esvm_esv_id:param.get('id'),
                                esvm_esv_name:param.get('name'),
                                esvm_name:infoEdit.esvm_name,
                                esvm_content:infoEdit.esvm_content,
                                esvm_update_uid:localStorage.getItem('eu_id'),
                                esvm_update_uname:localStorage.getItem('eu_name'),
                                esvm_id:editId,
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功！')   
                                    setOpenEdit(false)                             
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败！'+res.data.Message)
                                }
                            })
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client_edit"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 5 }}
                            ref={editForm}
                        >
                            <Form.Item label='应用名称' wrapperCol={{span:10}} required>
                                {param.get('name')}
                            </Form.Item>
                            <Form.Item name="esvm_name" label='权限' wrapperCol={{span:10}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,esvm_name:e.target.value}))}}/>
                            </Form.Item>
                            <Form.Item name="esvm_content" label='备注' wrapperCol={{span:15}} required>
                                <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,esvm_content:e.target.value}))}}/>
                            </Form.Item>
                        </Form>
                    </Modal>
    //删除设置-----------------------------------------------------------------------------------------------------------------------------删除设置
    const {confirm} = Modal; 
    const [submitDel] = useAppMenuDelMutation();
    //设置列表-----------------------------------------------------------------------------------------------------------------------------设置列表
    
    const {data,isSuccess} = useAppMenuListQuery({esvm_esv_id:param.get('id')})
    
    const [list, setList] = useState();
    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {esvm_id:key,esvm_name,esvm_content,esvm_uname,esvm_ctime,esvm_update_ctime,esvm_update_uname,esvm_num,esvm_price,sub_num} = item;
                    return item = {key,esvm_name,esvm_content,esvm_uname,esvm_ctime,esvm_update_ctime,esvm_update_uname,esvm_num,esvm_price,sub_num}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.esvm_ctime;
                    let bTimeString = b.esvm_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
   
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
       
        {
            key: 'type',
            title: '权限',
            dataIndex: 'esvm_name',
        },        
        {
            key: 'room',
            title: '备注',
            dataIndex: 'esvm_content',
        },       
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.esvm_ctime + record.esvm_uname}</div>
                    <div>修改时间：{record.esvm_update_ctime + record.esvm_update_uname}</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space direction='vertical'>                        
                        <a onClick={() => {
                            setEditId(record.key);
                            setOpenEdit(true)
                        }}>修改</a>
                        <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({esvm_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>
                        {/* <a onClick={() => {navi( `/TypeSon?id=${param.get('id')}&name=${param.get('name')}&tid=${record.key}&tname=${record.esvm_name}`, { state: {openKeys:'shop',active:"System"}})}}>子设置</a> */}
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main t1={param.get('name')} t2='权限'>
            <div>
                <Button type='primary' onClick={() => {setOpenAdd(true);}}>新增</Button>
            </div>
            <Table columns={columns} style={{marginTop:'20px'}} dataSource={list}></Table> 
            {modalAdd}
            {modalEdit}            
        </Main>
    )
}

export default AppLimit